import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Spinner } from "reactstrap";
import swal from "sweetalert";
import { APILA } from "../../../../../../config/apila";
import LoaderAction from "../../../../../Loader/LoaderHome";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import ToastError from "../../../../../NotificationToast/ToastError";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { faKey } from '@fortawesome/free-solid-svg-icons';


export default function Confirm({show, onHide, payload, onSuccess,}) {
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!show) {
      setLoading(false);
    }
  }, [show]);

  const handleApprove = async () => {
    setLoading(true);
    try {
      const res = await APILA.post(
        "/api/element-recaps-dimensi/approve-head",
        payload,
        {
          headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (res?.status === 200) {
        ToastSuccess.fire({
          icon: "success",
          title: res.data.message || "Nilai berhasil dikunci",
        });
        setLoading(false);      // ✅ RESET LOADING
        onHide();
        onSuccess && onSuccess();
      }
    } catch (err) {
      ToastError.fire({
        icon: "error",
        title: err?.response?.data?.message || "Gagal mengunci nilai",
      });
      
      // ⬅️ balik ke modal konfirmasi
      setLoading(false);
    } 
  };

  return (
    <Modal show={show} onHide={onHide} centered size="md">
       {loading ? (
          /* ============ LOADING VIEW ============ */
          <div className="d-flex flex-column align-items-center" style={{padding: "88px  50px"}}>
            <Spinner color="warning" style={{ width: 50, height: 50 }} />
            <h6 className="mt-4 mb-1">Mengunci Nilai</h6>
            <small className="text-muted mb-4">
              Mohon tunggu sebentar...
            </small>
          </div>
        ) : (
          <>
            <div className="d-flex justify-content-end p-2">
              <FontAwesomeIcon
                icon={faXmark}
                style={{ cursor: "pointer" }}
                onClick={onHide}
              />
            </div>
            <hr />

            <Modal.Body className="text-center">
              <FontAwesomeIcon icon={faKey} size="3x" className="mb-3" color="#f39c12"/>
                <h5 className="mb-2">Kunci Nilai 4 di Seluruh Sekolah Ini?</h5>
                <p style={{ fontSize: "14px" }}>
                    Nilai 4 yang sudah dikunci <b> tidak dapat diedit kembali</b>.
                </p>
                <p> Apakah Anda yakin ingin mengunci nilai?</p>
              
                {loading && <LoaderAction />}
              
                <div className="d-flex justify-content-center mt-4 mb-4">
                  <Button className=" mr-2" color="secondary" onClick={onHide} disabled={loading} style={{fontSize: "13px"}}> Batal </Button>

                  <Button className=" " style={{fontSize: "13px"}} color="primary"  onClick={handleApprove} disabled={loading}>
                    Ya, Kunci Nilai 
                  </Button>
                </div>
            </Modal.Body>
          </>
        )}
      
    </Modal>
  );
}
